import { jsonApiVuex } from '@common/store/json-api-vuex';

export const privacyCookieScannerSettingCustomField = jsonApiVuex(
  'privacy/cookie-scanner/setting/custom-field',
  {},
  {}
);
